import React from "react";
import { Container, Row, Col, span } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { movieAction } from "../redux/action/movieAction";
import Video from "../component/Video";
import Review from "../component/Review";


const Moviedetail = () => {
  const dispatch = useDispatch();
  const {
    popularMovies,
    topRatedMovies,
    upcomingMovies,
    loading,
    genreList,
    movieDetail,
  } = useSelector((state) => state.movie);
  console.log("무비디테일페이지 movieDetail:", movieDetail);
  const { id } = useParams();

  useEffect(() => {
    dispatch(movieAction.getMovieDetail(id));
    dispatch(movieAction.getMovies());
  }, [id, dispatch]);

  return (
    <div className="detail_wrap">
      <Container className="detail_wrap">
        <Row>
          <Col lg={6} className="detail_section detail_img_card">
            <div
              className="detail-img"
              style={{
                backgroundImage:
                  "url(" +
                  ` https://www.themoviedb.org/t/p/w300_and_h450_bestv2${movieDetail?.poster_path}` +
                  ")",
              }}
            ></div>
          </Col>

          <Col lg={6} className="detail_section">
            <ul className="details-genres">
              {/* genres 배열이 있는지 확인 후 렌더링 */}
              {movieDetail.genres &&
                movieDetail.genres.map((genre, idx) => (
                  <li key={idx}>{genre.name}</li>
                ))}
            </ul>
            <div className="detail_title">{movieDetail?.title}</div>
            <div className="detail_tagline">{movieDetail?.tagline}</div>
            <hr />
            <div className="detail_overview">{movieDetail?.overview}</div>
            <hr /> <hr />
            <div className="detail_info">
              <div>
                <span text="light">Release Date</span>
                <span className="span-text">{movieDetail?.release_date}</span>
              </div>
              <div>
                <span text="light">Budget</span>
                <span className="span-text">{movieDetail?.budget}</span>
              </div>
              <div>
                <span text="light">Runtime</span>
                <span className="span-text">{movieDetail?.runtime}</span>
              </div>
              <div>
                <span text="light">Popularity</span>
                <span className="span-text">{movieDetail?.popularity}</span>
              </div>
              <div className="adult-info">
                <span>
                  {movieDetail?.adult ? "청소년관람가" : "청소년관람불가"}
                </span>
              </div>
            </div>
            <hr />
            <div>
              {/* {
                movieDetail?.video === true ?<Video /> : ''
              }  */}
              <Video />
            </div>
          </Col>
        </Row>

        <Review />
      </Container>
    </div>
  );
};

export default Moviedetail;
